import QRCode from 'qrcode';

/** Copy to clipboard, falling back to a hidden textarea on older/insecure contexts. */
export async function copyToClipboard(text: string): Promise<boolean> {
    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            return true;
        }
    } catch {
        // fall through to the legacy path
    }

    try {
        const area = document.createElement('textarea');
        area.value = text;
        area.style.position = 'fixed';
        area.style.opacity = '0';
        document.body.appendChild(area);
        area.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(area);
        return ok;
    } catch {
        return false;
    }
}

/** True when the device offers the native share sheet — mobile, mostly. */
export function canNativeShare(): boolean {
    return typeof navigator !== 'undefined' && typeof navigator.share === 'function';
}

export async function nativeShare(title: string, text: string, url: string): Promise<void> {
    if (!canNativeShare()) return;
    try {
        await navigator.share({ title, text, url });
    } catch {
        // A cancelled share sheet rejects — that isn't an error worth surfacing.
    }
}

/** Render the referral link as a QR data URL, sized for both preview and download. */
export function generateQrDataUrl(url: string, size = 512): Promise<string> {
    return QRCode.toDataURL(url, {
        width: size,
        margin: 2,
        color: { dark: '#151515', light: '#ffffff' },
        errorCorrectionLevel: 'M',
    });
}

export function downloadDataUrl(dataUrl: string, filename: string): void {
    const link = document.createElement('a');
    link.href = dataUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
